<template>
  <v-content>
    <v-container fluid>
      <Header :title="title" />
      <v-row no-gutters>
        <v-col cols="12">
          <DataTable
            @editing="editing"
            @deleting="deleting"
            :title="''"
            :headers="headers"
            :items="equipmentgroupdata"
            :search="search"
          />
        </v-col>
        <Dialogbox
          @closing="closing"
          @deleteuser="deleteEquipmentGroup"
          :title="dialogboxtitle"
          :dialog="dialogstatus"
          :buttonTitle="dialogButtontitle"
          :deleteuser="true"
          v-if="dialogstatus"
        />
      </v-row>
    </v-container>
    <v-btn dark fab fixed bottom right large color="pink" class="mx-2" @click="addEquipmentGroup">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </v-content>
</template>

<script>
import { mapGetters } from "vuex"
import store from "@/store"
import {
  FETCH_EQUIPMENT_GROUP_DATA,
  DELETE_EQUIPMENT_GROUP_DATA,
  RESET_STATE
} from "@/store/actions.type";
import { SET_LOADING, SET_ROUTER_ENTER } from "@/store/mutations.type"
export default {
  name: "EquipmentGroups",
  beforeRouteEnter(to, from, next) {
    store.dispatch(RESET_STATE)
    store.dispatch(FETCH_EQUIPMENT_GROUP_DATA, "").then(resp => {
      if (resp.success) {
        store.commit(SET_LOADING, false)
        store.commit(SET_ROUTER_ENTER, false)
      }
    });
    return next();
  },
  beforeRouteLeave(to, from, next) {
    store.dispatch(RESET_STATE)
    next();
  },
  data: function() {
    return {
      title: "Equipment group",
      search: "",
      dialogstatus: false,
      dialogButtontitle: null,
      dialogboxtitle: null,
      equipmentgroupid: null,
      singleSelect: "",
      dialog: false,
    };
  },
  components: {
    DataTable: () => import("@/components/datatable/datatable"),
    Dialogbox: () => import("@/components/dialog/dialog"),
    Header: () => import("@/components/header/Header")
  },
  computed: {
    ...mapGetters(["equipmentgroupdata",'currentUser']),
    headers () {
      return [
        { text: this.$t("Group id"), value: "equip_group_id" },  
        { text: this.$t("Name"), value: "equip_group_name" },        
        { text: this.$t("Actions"), value: "action", sortable: false }
      ]
    }
  },
  created (){
    if(this.currentUser.roles.includes(1) == false){
      this.$router.push('/dashboard');
    }
  },
  methods: {
    addEquipmentGroup() {
      this.$router.push("/equipment-group/add");
    },
    editing(id) {
      this.$router.push("/equipment-group/edit/" + id)
    },
    deleting(id) {
      this.dialogstatus = true
      this.dialogboxtitle = "Are you sure want to remove?"
      this.dialogButtontitle = "Remove"
      this.equipmentgroupid = id
    },
    async deleteEquipmentGroup() {
      await this.$store
        .dispatch(DELETE_EQUIPMENT_GROUP_DATA, this.equipmentgroupid)
        .then(async resp => {
          if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
            this.equipmentgroupid = null;
            await store.dispatch(FETCH_EQUIPMENT_GROUP_DATA, "").then(resp => {
              if (resp.success) {
                store.commit(SET_LOADING, false);
                this.dialogstatus = false;
              }
            });
          }
          else{
            store.commit(SET_LOADING, false);
          }
        });
    },
    closing() {
      this.dialogstatus = false
    },
  }
};
</script>